import React, { useMemo } from 'react';

import classNames from 'classnames/bind';
import style from './styles.module.scss';
import { useTable } from 'react-table';

const cx = classNames.bind(style);

const Table = (props) => {
  const data = useMemo(() => props.data, [props.data]);
  const columns = useMemo(() => props.columns, [props.columns]);
  const { onChagneTabs, tabs, selectedTab } = props;

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  return (
    <div className={cx('Table', props.className)}>
      {tabs && (
        <div className={cx('tab-container')}>
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={cx('tab', selectedTab === tab.value && 'selected')}
              onClick={() => onChagneTabs(tab.value)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      )}
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  const isRenderFunction = typeof cell.value === 'function';
                  const customCell = isRenderFunction ? cell.value() : cell.render('Cell');

                  return <td {...cell.getCellProps()}>{customCell}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
